import { Coordinates, Language } from '@/core/interface'
import { InterestPoint } from '@/core/interface/Catalog'
import { serverapi } from '@/core/serverapi'
import { buildParams } from '@/core/utils/api'

import { api } from './axios.config'

export interface IGetPlaces extends Coordinates {
  locale: Language
}

export const getPoints = async (): Promise<InterestPoint[] | undefined> => {
  try {
    const { data } = await api.get<InterestPoint[]>('en/landmarks.json')
    return data
  } catch (e) {
    console.error('Landmarks Error', e)
  }
}
